import { useQuery } from '@tanstack/react-query';
import apiClient from '../../lib/api';
import type { ContactLogDetail } from '../../types/contactLog';

/**
 * 連絡帳データを取得するカスタムフック
 * @param patientId 患者ID
 * @param date 日付 (YYYY-MM-DD形式)
 * @param includePastImages 過去の写真を含めるかどうか (デフォルト: false)
 * @returns React Query の結果
 */
export const useContactLog = (patientId: number | null, date: string, includePastImages: boolean = false) => {
  return useQuery<ContactLogDetail>({
    queryKey: ['contactLog', patientId, date, includePastImages],
    queryFn: async () => {
      if (!patientId) {
        throw new Error('Patient ID is required');
      }
      return await apiClient.getContactLog(patientId, date, includePastImages);
    },
    // 患者IDがnullの場合は実行しない
    enabled: patientId !== null && !!apiClient.getIdToken(),
    // エラー時のリトライ設定
    retry: 1,
    // データがない場合は404エラーになるが、それは正常なケースとして扱う
    retryOnMount: false,
  });
};

export default useContactLog;
